import { TextLineSpacing } from "@wix/wix-ui-icons-common";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isNodeSelected } from "./../_shared/resolvers/is-node-selected.js";
import { lineSpacingModals } from ".//consts.js";
import { TEXT_BUTTON_LINE_SPACING } from "./data-hooks.js";
import LineSpacingPanelComponent from "./LineSpacingPanelComponent.js";
const getTextButtons = () => {
  return [
    {
      id: "LINE_SPACING",
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_LINE_SPACING,
        tooltip: "LineSpacingButton_Tooltip",
        icon: TextLineSpacing
      },
      attributes: {
        visible: isAlwaysVisible,
        disabled: isNodeSelected
      },
      modal: {
        id: lineSpacingModals.spacingOptions,
        Component: LineSpacingPanelComponent
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
